export default class AccountForms {
    constructor() {
        this.formWrapper = document.querySelector('.js-labeled-inputs');
        this.observerConfig = {
            childList: true,
            subtree: true
        };

        if (!this.formWrapper) {
            return;
        }

        this.items = this.formWrapper.querySelectorAll('.ur-field-item');

        this.init();
        this.errorHandler();
    }

    init() {
        // password show/hide
        let passwordsBtns = this.formWrapper.querySelectorAll('.js-pass-show-btn');

        if (passwordsBtns.length > 0) {
            for (let passwordsBtn of passwordsBtns) {
                this.passwordRevealController(passwordsBtn);
            }
        }

        // input label positioning
        let textInputs = this.formWrapper.querySelectorAll('input[type="text"]');
        let mailInputs = this.formWrapper.querySelectorAll('input[type="email"]');
        let passwordInputs = this.formWrapper.querySelectorAll('input[type="password"]');
        let telInputs = this.formWrapper.querySelectorAll('input[type="tel"]');

        if (textInputs.length > 0) {
            for (let textInput of textInputs) {
                this.inputController(textInput);
            }
        }

        if (mailInputs.length > 0) {
            for (let mailInput of mailInputs) {
                this.inputController(mailInput);
            }
        }

        if (passwordInputs.length > 0) {
            for (let passwordInput of passwordInputs) {
                this.inputController(passwordInput);
            }
        }

        if (telInputs.length > 0) {
            for (let telInput of telInputs) {
                this.inputController(telInput);
            }
        }
    };

    passwordRevealController(btn) {


        btn.addEventListener('click', () => {
            if (btn.classList.contains('is-visible')) {
                btn.classList.remove('is-visible');
                this.hidePass(btn);
                return;
            }
            this.showPass(btn);
            btn.classList.add('is-visible');
        });
    }

    showPass(btn) {
        let input = btn.parentNode.querySelector("input");

        input.type = "text";
    }

    hidePass(btn) {
        let input = btn.parentNode.querySelector("input");

        input.type = "password";
    }

    inputController(input) {
        let wrapper = input.parentNode;

        if (!wrapper.classList.contains('ur-field-item')) {
            wrapper = input.parentNode.parentNode;
        }

        input.addEventListener('focus', () => {
            wrapper.classList.add('is-focused');
        });

        input.addEventListener('blur', () => {
            if (input.value === "" || input.value == null) {
                wrapper.classList.remove('is-focused');
            }
        });

        if (input.value === "" || input.value == null) {
            wrapper.classList.remove('is-focused');
        } else {
            wrapper.classList.add('is-focused');
        }
    }

    errorHandler() {
        const callback = (mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    this.spacingController();
                }
            }
        };


        const observer = new MutationObserver(callback);

        observer.observe(this.formWrapper, this.observerConfig);

        // observer.disconnect();
    }


    spacingController() {
        for (let item of this.items) {
            if (item.querySelector('.user-registration-error') &&
                item.querySelector('.user-registration-error').style.display !== "none") {
                item.classList.add("has-error");
            } else {
                item.classList.remove("has-error");
            }
        }
    }
}
